import { AxiosError } from 'axios'

export const getRequestErrorMessage = (error: AxiosError<{message?: string | string[]}>): string => {
	switch (error.response?.status) {
		case 401:
			return 'Recurso apenas para usuários autenticados'
		case 403:
			return 'Não tem permissão'
		case 405:
			return 'Método não permitido'
		case 500:
		case 503:
			return 'Ocorreu um erro interno, contate o suporte'
	}
	if (error.response && error.response.data) {
		const message = error.response.data.message
		if (!message) return error.response.data.toString()
		return Array.isArray(message)
			? message.join('; ')
			: message
	}
	return error.message
}
